var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "proposal-token-history" },
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("filter-manager", {
        staticClass: "proposal-token-history__filter-manager",
        attrs: { "display-advanced": false, filters: _vm.filtersConfig },
        on: { academicYear: _vm.onAcademicYearChange, search: _vm.search },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultado de Código de Acesso" }
      }),
      _vm._l(_vm.page.data, function(result, index) {
        return _c(
          "div",
          { key: index },
          [_c("token-history-result", { attrs: { value: result } })],
          1
        )
      }),
      _vm.page.data.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible" }
          })
        : _vm._e(),
      _vm.page.data.length > 0 && _vm.page.totalItemCount > _vm.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.page, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }